module.exports = __webpack_public_path__ + "static/media/armenia.3f177416.svg";